"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M4 7h12a1 1 0 010 2H4a1 1 0 110-2zm0 4h12a1 1 0 010 2H4a1 1 0 010-2z"];
//# sourceMappingURL=equals.js.map